import { initializeConnector } from '@web3-react/core'
import { EthAdapter } from '../../../../contexts/MetaMaskAdapter'

export const [metaMask, hooks] = initializeConnector((actions) => new EthAdapter({ actions }))